/* src/utils/formatNumber.js
   ──────────────────────────────────────────────────────────────
   Formats a numeric value with Danish comma decimals.
   If the value is not finite, it returns the en-dash “—”.

   @param {number} value
   @param {number} decimals  Minimum & maximum decimal places (default = 2)
*/
export default function formatNumber(value, decimals = 2) {
    if (!Number.isFinite(value)) return '—';

    return value.toLocaleString('da-DK', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
}
